import React from "react";
import Fancybox from "../Fancybox";
import { useField } from "formik";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { useTranslation } from "../../context/TranslationContext";
import { renderToString } from "react-dom/server";

const Contract = ({ text, content, ...props }) => {
  const { contractText } = useTranslation();
  const [field, meta, helpers] = useField(props);

  const El = () => {
    return (
      <span
        data-fancybox="dialog"
        data-src={"#" + props.name + "-content"}
        className="font-bold"
      >
        {text}
      </span>
    );
  };
  return (
    <Fancybox options={{ infinite: false }}>
      <div className="relative inline-block w-full sm:w-auto">
        <input
          type="checkbox"
          {...props}
          {...field}
          id={props.name}
          onChange={(e) => {
            helpers.setValue(e.target.checked);
          }}
          className="w-0 h-0 absolute peer"
        ></input>
        <label
          htmlFor={props.name}
          className="text-13  text-black pl-7 py-2 cursor-pointer"
          dangerouslySetInnerHTML={{
            __html: contractText.replace(
              /\{contractName\}/g,
              renderToString(<El />)
            ),
          }}
        ></label>
        <span className="w-5 h-5 pointer-events-none rounded-sm border-2 transition-colors border-brand-gray-8 absolute left-0 top-0 mt-1 peer-checked:bg-brand-gray-8"></span>
        <FaCheck
          size={12}
          className="absolute left-1 top-2 opacity-0 peer-checked:opacity-100 pointer-events-none"
        ></FaCheck>
      </div>
      <div
        id={props.name + "-content"}
        className="hidden max-w-[90%] break-words"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      ></div>
    </Fancybox>
  );
};

export default Contract;
